import type { CustomActionButton } from "./PersonSideSheet";

const PROFILE_ACTION_LABELS = new Set(["view full profile"]);

export function isProfileNavigationAction(label: string): boolean {
  return PROFILE_ACTION_LABELS.has(label.trim().toLowerCase());
}

export function getPersonProfileOverviewPath(pgaId: string): string {
  return `/people/${pgaId}/person/overview`;
}

export function openPersonProfileInNewTab(pgaId: string): void {
  window.open(getPersonProfileOverviewPath(pgaId), "_blank", "noopener,noreferrer");
}

export function partitionSideSheetActionButtons(customActionButtons?: CustomActionButton[]) {
  const footerPrimaryActions: CustomActionButton[] = [];

  for (const button of customActionButtons ?? []) {
    if (!isProfileNavigationAction(button.text)) {
      footerPrimaryActions.push(button);
    }
  }

  return footerPrimaryActions;
}
